import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-info-tooltip-component",
  templateUrl: "./info-tooltip-component.component.html",
  styleUrls: ["./info-tooltip-component.component.scss"],
})
export class InfoTooltipComponentComponent implements OnInit {
  @Input() infoTooltip: string;
  @Input() placement: string
  constructor() {}

  ngOnInit(): void {}
}
